
import { useParams } from 'react-router';
import AssetPanel from '../Assets/AssetPanel';

type Params = {
  searchTerm: string;
};

const AssetVehicles = () => {
  const { searchTerm } = useParams<Params>();
  return <AssetPanel
    searchTerm={searchTerm}
    tabIndex={2}
  />
}

export default AssetVehicles;
